import { Box, Card } from '@mui/material'
import React, { useEffect, useState } from 'react'
import { Controller, useForm } from 'react-hook-form'
import HeaderLine from 'src/Common/ui/HeaderLine'
import SelectInput from 'src/Common/ui/selectInput'
import Input from 'src/Common/ui/input'
import { t } from 'i18next'

import { useGovernanceStore } from '../Onboarding/Store/GovernanceStore'
import { RxCross2 } from 'react-icons/rx'
import { LiaSaveSolid } from 'react-icons/lia'
import { Button } from '../../Common/ui/button'
import { toast } from 'react-toastify'
import DatePickerInput from 'src/Common/ui/DatePickerInput'
import { useIssueStore } from './store/IssueStore'
import Justification from '../Risk/MitigationComponents/Justification'
import Assessors from '../Risk/MitigationComponents/Assessors'
import Tasktable from '../Risk/MitigationComponents/Tasktable'
import { RESOLUTION_APPROACH, RESOLUTION_ID } from 'src/Entities/IssueTypes'
import { createIssuePlanning } from 'src/API/IssueApi'
import Loading from 'src/Common/ui/Loading'

const IssuePlanningEdit = ({ setIsEditTrue }) => {
    const { control, errors } = useForm()
    const issueDetailsData = useIssueStore(state => state.issueDetailsById)
    const [ getData, setGetData ] = useState({})
    const { getIssueDetailsById } = useIssueStore()
    useEffect(() => {
        if (issueDetailsData?.planningResponse) {
            const data = issueDetailsData?.planningResponse
            if (data?.taskLists?.length === 0 || !data?.taskLists) {
                data.taskLists = issueDetailsData?.issueInformation?.resolutionPlan
            }
            setGetData(data)
            getDepOrganizations(orgId)
        }
    }, [issueDetailsData])
    const onValueSelectChange = (key, value) => {
        if (key === 'approachId') {
            const data = getData
            if (data?.taskLists?.length === 0) {
                data.taskLists = issueDetailsData?.issueInformation?.resolutionPlan
            }
            setGetData({ ...data, [key]: value })
        } else {
            setGetData({ ...getData, [key]: value })
        }
    }
    const onInputChange = (key, e) => {
        setGetData({ ...getData, [key]: e.target.value })
    }
    const taskSelectChange = (value, index, dateType) => {
        setGetData({
            ...getData,
            taskLists: getData.taskLists.map((item, i) => {
                if (i === index) {
                    item[dateType] = value
                }
                return item
            })
        })
    }
    const taskInputChange = (e, index, dateType) => {
        setGetData({
            ...getData,
            taskLists: getData.taskLists.map((item, i) => {
                if (i === index) {
                    item[dateType] = e
                }
                return item
            })
        })
    }
    const userId = localStorage.getItem('userId')

    const handleAddTask = () => {
        const addData = getData.taskLists
        addData.push({
            id: 0,
            riskId: issueDetailsData?.issueInformation?.id,
            name: '',
            startDate: null,
            endDate: null,
            departmentId: null,
            responsible: '',
            actions: null,
            createdBy: userId,
            status: 11,
            createdAt: new Date().toISOString(),
            modifiedBy: userId,
            modifiedAt: new Date().toISOString()
        })
        setGetData({
            ...getData,
            taskLists: addData
        })
    }
    const handleDeleteTask = (index) => {
        setGetData({
            ...getData,
            taskLists: getData.taskLists.filter((item, i) => i !== index)
        })
    }
    const { getDepOrganizations, allDepartments } = useGovernanceStore()
    const [ departments, setDepartments ] = useState([])
    const orgId = localStorage.getItem('orgId')
    const [ loading, setLoading ] = useState(false)
    useEffect(() => {
        if (allDepartments.length > 0) {
            setDepartments(allDepartments)
        }
    }, [allDepartments])
    useEffect(() => {
        getDepOrganizations(orgId)
    }, [])
    const onSubmit = (message) => {
        setLoading(true)
        const data = JSON.parse(JSON.stringify(getData))
        if (data.approachId === RESOLUTION_ID) {
            data.createTasks = { riskId: issueDetailsData?.issueInformation?.id, riskScore: issueDetailsData?.analyzeResponse?.qualitativeRiskAssessment, taskListRequests: getData.taskLists }
            data.availableAmount = +data.availableAmount || 0
            data.mitigationBudget = +data.mitigationBudget
        }
        data.riskId = issueDetailsData?.issueInformation?.id
        data.modifiedBy = userId
        delete data.scoring
        delete data.taskLists
        delete data.modifiedAt
        createIssuePlanning(data).then((res) => {
            if (res?.data) {
                toast.success(<p className='w-[100%] flex flex-row justify-evenly items-center' ><p>{message.replace('[ID]', issueDetailsData?.issueInformation?.referenceId)}</p></p>, {
                    position: 'top-right', theme: 'light'
                })
                getIssueDetailsById(Number(issueDetailsData?.issueInformation?.id), userId)
                setIsEditTrue(false)
                setLoading(false)
            } else {
                toast.error(<p className='w-[70%] flex flex-row justify-evenly items-center' ><p color='hsl(var(--card))'>End Date should be lesser than Resolution Date</p></p>, {
                    position: 'top-right', hideProgressBar: true, theme: 'light'
                })
                setLoading(false)
            }
        })
    }

    const handleCancel = () => {
        setIsEditTrue(false)
    }
    const labelType = () => {
        switch (getData?.approachId) {
        case RESOLUTION_ID:
            return 'Root Cause'
        default:
            return 'Justification'
        }
    }
    return (

        <div className='h-[100%] w-[100%]'>
            <Loading isLoading={loading} />
            <Card className="flex flex-col h-[100%] gap-4 p-4 flex-shrink-0">
                <div className='h-[90%] px-2 !overflow-scroll'>
                    <HeaderLine text={'Resolution Plan'} />
                    <Box display="grid" sx={{ pt: 2 }} gridTemplateColumns="1fr 3fr" gap={2}>
                        <Box gridColumn="span 1">
                            <SelectInput
                                label={'Approach'}
                                control={control}
                                errors={errors}
                                name="category"
                                placeholder="Select"
                                onValueChange={(value) => onValueSelectChange('approachId', value)}
                                value={getData.approachId}
                                defaultValue={getData.approachId}
                                options={RESOLUTION_APPROACH}
                            />
                        </Box>
                        <Box gridColumn="span 1">
                            <Justification control={control} reviewDate={getData?.reviewDate} data={getData?.justification} onInputChange={onValueSelectChange} type={null} errors={errors} label={labelType()}/>
                        </Box>
                    </Box>
                    <Box display="grid" sx={{ pb: 2 }} gridTemplateColumns="repeat(4, 1fr)" gap={2}>
                        {getData.approachId === RESOLUTION_ID && <>
                            <Box gridColumn="span 1">
                                <Input
                                    errors={errors}
                                    control={control}
                                    rules={{
                                        // validate: (value) => {
                                        //     return inputValidation(value, value?.length < 251, t('This field is required'), t('Characters should be less than 250'))
                                        // }s
                                    }}
                                    name='breif-description'
                                    label={t('Resolution Budget')}
                                    placeholder="Enter Resolution Budget"
                                    type="number"
                                    onValueChange={(e) => { onInputChange('mitigationBudget', e) }}
                                    value={getData?.mitigationBudget}
                                    maxLength={250}
                                />
                            </Box>
                            {/* <Box gridColumn="span 1">
                                <Input
                                    errors={errors}
                                    control={control}
                                    rules={{
                                        validate: (value) => {
                                            return inputValidation(value, value?.length < 251, t('This field is required'), t('Characters should be less than 250'))
                                        }
                                    }}
                                    name='breif-description'
                                    label={t('Available Amount')}
                                    placeholder="Enter Available Amount"
                                    type="number"
                                    onValueChange={(e) => onInputChange('availableAmount', e)}
                                    value={getData?.availableAmount}
                                    maxLength={250}
                                />
                            </Box> */}
                        </>}
                    </Box>
                    {
                        getData.approachId === RESOLUTION_ID && <>
                            <HeaderLine text={'Task List'} />
                            <div className='py-4'>
                                <Assessors data={issueDetailsData?.analyzeResponse?.qualitativeRiskAssessment} type='ISSUE'/>
                            </div>
                            <Box display="grid" gridTemplateColumns="repeat(4, 1fr)" sx={{ py: 2 }} gap={2}>
                                {
                                    getData.approachId === RESOLUTION_ID && <Controller name="actions"
                                        // rules={getData.type === ACCEPTANCE_ID ? { required: 'This field is Required' } : {}}
                                        control={control}
                                        errors={errors}
                                        render={({ field: { onChange } }) => (<Box gridColumn="span 1">
                                            <DatePickerInput
                                                label={'Resolution Date'}
                                                name={'selectedDate'}
                                                required
                                                className={'input-grc'}
                                                value={getData?.resolutionDate}
                                                errors={errors}
                                                control={control}
                                                // minDate={item?.startDate || ''}
                                                // maxDate={fromMaxDate}
                                                // name="selectedDate"
                                                onValueChange={(e) => {
                                                    const val = e
                                                    onValueSelectChange('resolutionDate', val)
                                                    onChange(val)
                                                }}
                                            />
                                        </Box>)}
                                    />
                                }
                            </Box>
                            <Tasktable handleAddTask={handleAddTask} handleDeleteTask={handleDeleteTask} taskInputChange={taskInputChange} taskSelectChange={taskSelectChange} data={getData?.taskLists} departments={departments} control={control} errors={errors} />
                        </>
                    }
                </div>
                {getData.approachId !== null && <div className="h-[10%] flex justify-end items-center space-x-4">
                    <Button
                        onClick={() => handleCancel()}
                        variant='outline'
                        style={{ color: 'hsl(var(--destructive))', borderColor: 'hsl(var(--destructive))' }}
                    >
                        <RxCross2 className="mr-2" size={18} /> {t('Cancel')}
                    </Button>
                    <Button onClick={() => onSubmit('Planning has been completed for Issue [ID]')} disabled={loading}>
                        <LiaSaveSolid className="mr-2" size={15} /> Save
                    </Button>
                </div>}
            </Card>
        </div>
    )
}

export default IssuePlanningEdit
